let Promise = require("es6-promise").Promise;

HTMLDocument.prototype.ready = new Promise(resolve => {
  if (document.readyState != "loading") {
    resolve();
  } else {
    document.addEventListener("DOMContentLoaded", () => resolve());
  }
});
